import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { object, shape, string } from 'prop-types'
import { useTheme } from 'emotion-theming'

import { SiteConfigContext } from '../SiteConfigProvider'
import { Thumbnail } from '../Thumbnail'
import { AuthorByline } from '../AuthorByline'

const AuthorCardContainer = styled.div`
	border: 1px solid ${({ theme }) => theme.colors.grey01};
	margin: 0.5rem auto 1.5rem auto;
	width: 100%;
`
const AuthorCardTopSection = styled.div`
	display: flex;
	justify-content: stretch;
	padding: 1rem 1rem 0.5rem;
	position: relative;
`
const AuthorCardBottomSection = styled.div`
	display: flex;
	flex-direction: column;
	margin: 1rem 2rem;
	padding: 0.5rem 0;

	${({ theme }) => theme.MQ.XL} {
		margin: 1rem 80px;
	}
`
const AuthorDetail = styled.div`
	display: block;
	padding-left: 15px;
`
const AuthorDetailName = styled.div`
	${({ theme }) => theme.fonts.header}
	color: ${({ theme }) => theme.authorBio.staffName};
	font-size: 16px;
	font-weight: 400;
	line-height: 1.1em;
	margin-bottom: 0.5rem;
	overflow: hidden;
`
const AuthorDetailSite = styled(AuthorDetailName)`
	color: ${({ theme }) => theme.authorBio.staffSite};
`

const AuthorDescription = styled.div`
	border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
	color: ${({ theme }) => theme.colors.darkGrey};
	font-size: 16px;
	letter-spacing: 0.26px;
	line-height: 1.5rem;
	padding-top: 1rem;
`
const BlockMonogramContainer = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	width: 80px;
`
const BlockMonogramWrapper = styled.div`
	overflow-x: hidden;
	display: none;

	${({ theme }) => theme.MQ.M} {
		display: inherit;
	}
`
// const SocialProfileButtonsContainer = styled.div`
// 	display: flex;
// 	margin-top: 1rem;
// 	overflow: hidden !important;
// 	width: 100%;

// 	${({ theme }) => theme.MQ.M} {
// 		width: 75%;
// 	}
// `
const TitleAndImage = styled.div`
	display: flex;
	width: 100%;
`

export const AuthorCard = ({ author: { bio, name, social, thumbnail, type = 'Contributing Writer' } }) => {
	const {
		siteComponents: { BlockMonogram },
	} = useContext(SiteConfigContext)

	const {
		colors: { lightGrey },
	} = useTheme()

	return (
		<AuthorCardContainer>
			<AuthorCardTopSection>
				<TitleAndImage>
					<Thumbnail alt={name} src={thumbnail} size="small" variant="avatar" height={50} width={50} />
					<AuthorDetail>
						<AuthorDetailName>{name}</AuthorDetailName>
						<AuthorDetailSite>
							<AuthorByline type={type} />
						</AuthorDetailSite>
					</AuthorDetail>
				</TitleAndImage>
				<BlockMonogramContainer>
					<BlockMonogramWrapper>
						{/* lightGrey works here because BndBlockMonogram has the color hard coded. If that were to change, we would need to update how we pass the color in */}
						<BlockMonogram color={lightGrey} height="100%" width="100%" />
					</BlockMonogramWrapper>
				</BlockMonogramContainer>
			</AuthorCardTopSection>
			<AuthorCardBottomSection>
				<AuthorDescription>{bio}</AuthorDescription>
				{/* 
					COMMENTING THIS OUT FOR NOW TO ELIMIATE 404 ISSUES
					Need to come back to this once we resolve bad data and add url validation on the graphql or mongo side
					https://bizdotcom.atlassian.net/browse/BIZ-3148
				*/}
				{/* {social && (
					<SocialProfileButtonsContainer>
						<SocialProfileButtons buttons={social} />
					</SocialProfileButtonsContainer>
				)} */}
			</AuthorCardBottomSection>
		</AuthorCardContainer>
	)
}

AuthorCard.propTypes = {
	author: shape({
		bio: string,
		name: string,
		social: object,
		thumbnail: string,
		type: string,
	}),
}
